import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

const StyledProgramPlaybookQuestionDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(860px, calc(100vw - 28px));
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .MuiFormControl-root {
    margin: 6px 0;
  }

  h5 {
    font-size: 16px;
    margin: 10px 0;
  }
  font-size: 14px;

  .subcategory-section {
    .MuiFormControlLabel-root {
      transform: scale(0.85);
    }
  }

  .answer-option-text-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .answer-option {
    border-radius: 10px;
    padding: 8px 12px;
    font-size: 14px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background: var(--cms-surface-muted);
    color: var(--cms-text-primary);
    border: 1px solid var(--cms-border);
    box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em,
      rgba(90, 125, 188, 0.05) 0px 0.25em 1em;

    .MuiChip-root {
      margin-right: 20px;
      min-width: 110px;
    }
  }
`

export { StyledProgramPlaybookQuestionDialog }
